import React, {useEffect, useState} from "react";
import {DateInput} from "@/component/input/DateInput";
import {AmountInput} from "@/component/input/AmountInput";
import {FtDialog} from "@/common/FtDialog";
import {useAccountStore} from "@/store/useAccountStore";
import {LoadableView} from "@/component/view/LoadableView";
import {UpdateTransLimitReq} from "@/common/req/UpdateTransLimitReq";
import {InputWrap} from "@/component/input/InputWrap";
import {StringInput} from "@/component/input/StringInput";
import {FtButton} from "@/common/FtButton";
import {useDeleteTransLimit, useTransLimit, useUpdateTransLimit} from "@/hook/useTransLimits";

interface Props {
    transLimitId: number;
    handleClose: () => void;
}

export function EditTransLimitDialog(props: Props) {
    const {transLimitId} = props;
    const [data, setData] = useState<UpdateTransLimitReq | undefined>();
    const {data: transLimit, error} = useTransLimit(transLimitId);
    const updateTransLimit = useUpdateTransLimit();
    const deleteTransLimit = useDeleteTransLimit();
    const accountName = useAccountStore(state => transLimit ? state.getAccountNameById(transLimit.accountId) : "");

    useEffect(() => {
        if (!transLimit) return;
        setData({
            applyDate: transLimit.applyDate,
            amount: transLimit.amount,
            detail: transLimit.detail,
        });
    }, [transLimit]);

    async function handleSubmit() {
        if (!data) return;
        await updateTransLimit.mutateAsync({transLimitId, req: data});
        props.handleClose();
    }

    async function deleteAction() {
        if (!confirm("정말로 삭제할까요?")) return;
        await deleteTransLimit.mutateAsync(transLimitId);
        props.handleClose();
    }

    if (!open) return null;

    return (
        <FtDialog title="용돈 한도 수정" handleClose={props.handleClose}>
            <LoadableView data={data} error={error} component={(data) => (<>
                <div style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                    계정: {accountName}

                    <InputWrap label="적용일">
                        <DateInput
                            value={data.applyDate}
                            required={true}
                            onChange={(value) => setData({...data, applyDate: value})}
                        />
                    </InputWrap>

                    <InputWrap label="금액">
                        <AmountInput
                            fullWidth={true}
                            value={data.amount}
                            onChange={(value) => setData({...data, amount: value})}
                        />
                    </InputWrap>

                    <StringInput
                        placeholder="상세 내역"
                        value={data.detail}
                        onChange={(v) => setData({...data, detail: v})}
                        fullWidth
                    />
                </div>

                <div style={{display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16}}>
                    <FtButton variant="outlined" onClick={deleteAction}>삭제</FtButton>
                    <FtButton variant="contained" onClick={handleSubmit}>수정</FtButton>
                </div>
            </>)}/>
        </FtDialog>
    );
}
